import { render, staticRenderFns } from "./ComplianceProtection.vue?vue&type=template&id=93b59852&scoped=true"
import script from "./ComplianceProtection.vue?vue&type=script&lang=js"
export * from "./ComplianceProtection.vue?vue&type=script&lang=js"
import style0 from "./ComplianceProtection.vue?vue&type=style&index=0&id=93b59852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b59852",
  null
  
)

export default component.exports